export const SITES = 'sites';
export const SNAP_QUOTES = 'snap-quotes';
